// extracted by extract-css-chunks-webpack-plugin
module.exports = {"google-map":"GoogleMap-a12319b8d9852c30"};